import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MapViewsMenuWrapper from './MapViewsMenuWrapper';
import DemographicsMenu from './DemographicsMenu';
import SpatialSearchMenu from './SpatialSearchMenu';
import MapLayersMenu from './MapLayersMenu';
import NaicsMenu from './NaicsMenu';
import DrawMenu from './DrawMenu';
import { ViewerSecondaryColorUserStyle } from '../UserCustomization';
import svgInline from '../SvgInline/SvgInline';

import { map } from '../../featureConfig';

import ShareModal from '../Modal/ShareModal/ShareModal';

import heatmapIcon from './icon-map-heat-map.png';
import drawIcon from './icon-draw-map.png';
import spatialIcon from './icon-spatial-search.png';
import layersIcon from './icon-map-layers.png';
import viewsIcon from './icon-map-views.png';
import measureIcon from './icon-measure.png';
import printIcon from './icon-print-tool.png';
import shareIcon from './icon-share-tool.png';
import naicsIcon from './icon-naics-search.svg';
import workforceIcon from './icon-workforce.png';
import refreshIcon from '../../shared/assets/icon-refresh.svg';

import './MapToolbar.css';

function handlePrint() {
  window.print();
}

export class MapToolbarComponent extends Component {
  constructor() {
    super();
    this.state = { menu: '' };
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  componentDidMount() {
    this.props.resetPredefinedLayers(this.props.type);
  }

  handleMenuClick(name) {
    if (name === this.state.menu) {
      this.setState({ menu: '' });
      return;
    }
    this.setState({ menu: name });
  }

  render() {
    const {
      demographics,
      showShareModal,
      type,
      activateMeasure,
      deactivateMeasure,
      measure,
      zoom,
      toolsActive,
      resetMap,
      mapLoading,
      layers,
      layersActive,
      toggleWorkforce,
      isWorkforceActive,
      showWorkforceReports,
    } = this.props;

    const spatialLayers = (layers || []).filter(layer => layer.limitToOutline);
    const layersAreActive = layersActive();

    return (
      <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
        <div className="map-toolbar">
          <ShareModal includeFiltersAndSort />
          <ul>
            {map.layers &&
              <li ref={ref => { this.customButton = ref; }} className={this.state.menu === 'custom' ? 'active' : ''}>
                <a id="customLayers" className="toolbar-item map-layers-item" tabIndex="0" title="Layers" onClick={() => { this.handleMenuClick('map-layers'); }}>
                  <img src={layersIcon} alt="" />
                  <span className="tool-name">Layers</span>
                </a>
                { this.state.menu === 'map-layers' &&
                  <MapLayersMenu
                    onCloseClick={() => { this.handleMenuClick('map-layers'); }}
                    type={type}
                  />
                }
              </li>
            }
            {(map.draw && toolsActive) &&
              <li ref={ref => { this.drawButton = ref; }} className={this.state.menu === 'draw' ? 'draw active' : 'draw'}>
                <a id="customLayers" tabIndex="0" className="toolbar-item draw-item" title="Draw" onClick={() => { this.handleMenuClick('draw'); }}>
                  <img src={drawIcon} alt="" />
                  <span className="tool-name">Draw</span>
                </a>
                {this.state.menu === 'draw' &&
                  <DrawMenu
                    onCloseClick={() => { this.handleMenuClick('draw'); }}
                    type={type}
                  />
                }
              </li>
            }
            { spatialLayers.length > 0 &&
              <li ref={ref => { this.spatialSearchButton = ref; }} className={this.state.menu === 'spatialSearch' ? 'active' : ''}>
                <a id="customLayers" tabIndex="0" className="toolbar-item" title="Spatial Search" onClick={() => { this.handleMenuClick('spatialSearch'); }}>
                  <img src={spatialIcon} alt="" />
                  <span className="tool-name">Spatial Search</span>
                </a>
                { this.state.menu === 'spatialSearch' &&
                  <SpatialSearchMenu
                    onCloseClick={() => { this.handleMenuClick('spatialSearch'); }}
                    layers={spatialLayers}
                    type={type}
                  />
                }
              </li>
            }
            {false && // map.layers &&
              <li ref={ref => { this.naicsCodeButton = ref; }} className={this.state.menu === 'naics' ? 'active' : ''}>
                <a id="customLayers" className="toolbar-item naics-item" tabIndex="0" title="Business Data" onClick={() => { this.handleMenuClick('naics'); }}>
                  {svgInline(naicsIcon)}
                  <span className="tool-name">Business Data</span>
                </a>
                { this.state.menu === 'naics' &&
                  <NaicsMenu
                    onCloseClick={() => { this.handleMenuClick('naics'); }}
                    type={type}
                  />
                }
              </li>
            }
            <li ref={ref => { this.demographicsButton = ref; }} className={this.state.menu === 'demographics' ? 'active' : ''}>
              <a id="demographicsMenu" tabIndex="0" className="toolbar-item" title="Heat Maps" onClick={() => { this.handleMenuClick('demographics'); }}>
                <img src={heatmapIcon} alt="" />
                <span className="tool-name">Heat Maps</span>
              </a>
              {this.state.menu === 'demographics' &&
                <DemographicsMenu
                  demographics={demographics}
                  onCloseClick={() => { this.handleMenuClick('demographics'); }}
                  type={type}
                  zoom={zoom}
                />
              }
            </li>
            {showWorkforceReports && (
              <li>
                <a
                  className={`toolbar-item ${isWorkforceActive ? 'active' : ''}`}
                  tabIndex="0"
                  title="Workforce Data"
                  onClick={() => toggleWorkforce(type, !isWorkforceActive)}
                >
                  <img src={workforceIcon} alt="Workforce" />
                  <span className="tool-name">Workforce</span>
                </a>
              </li>
            )}
            {map.mapViews &&
              <li ref={ref => { this.mapButton = ref; }} className={this.state.menu === 'map' ? 'active' : ''}>
                <a id="mapMenu" tabIndex="0" className="toolbar-item" title="Map Views" onClick={() => { this.handleMenuClick('map'); }}>
                  <img src={viewsIcon} alt="Map Views" />
                  <span className="tool-name">Map Views</span>
                </a>
                {this.state.menu === 'map' && (
                  <MapViewsMenuWrapper
                    onCloseClick={() => { this.handleMenuClick('map'); }}
                  />
                )}
              </li>
            }
            {map.measure &&
              measure !== true &&
              <li>
                <a
                  className="toolbar-item"
                  tabIndex="0"
                  title="Measure"
                  onClick={activateMeasure}
                >
                  <img src={measureIcon} alt="Measure" />
                  <span className="tool-name">Measure</span>
                </a>
              </li>
            }
            {map.measure &&
              measure === true &&
              <li>
                <a
                  className="toolbar-item"
                  tabIndex="0"
                  title="Clear Measure"
                  onClick={deactivateMeasure}
                >
                  <img src={measureIcon} alt="Clear Measure" />
                  <span className="tool-name">Clear Measure</span>
                </a>
              </li>
            }
            {map.print &&
              <li>
                <a
                  className="toolbar-item"
                  tabIndex="0"
                  title="Print"
                  onClick={handlePrint}
                >
                  <img src={printIcon} alt="Print" />
                  <span className="tool-name">Print</span>
                </a>
              </li>
            }
            {map.share &&
              <li>
                <a
                  className="toolbar-item"
                  tabIndex="0"
                  title="Share"
                  onClick={showShareModal}
                >
                  <img src={shareIcon} alt="Share" />
                  <span className="tool-name">Share</span>
                </a>
              </li>
            }
            <li>
              <a
                className={mapLoading ? 'toolbar-item loading' : 'toolbar-item'}
                tabIndex="0"
                title="Clear Layers"
                onClick={() => { resetMap(layersAreActive, type); }}
              >
                {svgInline(refreshIcon)}
                <span className="tool-name">Reset</span>
              </a>
            </li>
          </ul>
        </div>
      </ViewerSecondaryColorUserStyle>
    );
  }
}

MapToolbarComponent.propTypes = {
  demographics: PropTypes.string,
  showShareModal: PropTypes.func.isRequired,
  activateMeasure: PropTypes.func.isRequired,
  deactivateMeasure: PropTypes.func.isRequired,
  measure: PropTypes.bool.isRequired,
  type: PropTypes.string,
  zoom: PropTypes.number,
  toolsActive: PropTypes.bool,
  resetPredefinedLayers: PropTypes.func.isRequired,
  mapLoading: PropTypes.bool,
  resetMap: PropTypes.func,
  layers: PropTypes.arrayOf(PropTypes.object),
  layersActive: PropTypes.func.isRequired,
  toggleWorkforce: PropTypes.func,
  isWorkforceActive: PropTypes.bool,
  showWorkforceReports: PropTypes.bool,
};

export default MapToolbarComponent;



// WEBPACK FOOTER //
// ./src/components/MapToolbar/MapToolbar.js